
import { defineStore } from 'pinia';
import type { User } from '@/types';
import avatar from '@/assets/images/logo/avatar.png';

export const UserStore = defineStore('user', {
  state: () => ({
    utilisateurConnecte: { id: 0, name: 'Doe', firstname: 'John' } as User,
    companieWork: null,
    connect: false,
    roles: [],
    currentProject: { id: '', project: '', role: {} as any },
    avatar: avatar,
    access_token: '',
    settings: { id: 0, logoUrl: "/uploads/images/default.jpg", paginationSize: 15, messagesFlash: [] },
    language: 'fr',
    currentStudy: { idStudy: '', codStudy: '', name: '', applicationId: '' },
    currentTypeDatabaseConnection: { type: '', codStudy: '', name: '', applicationId: '' },
    layerdata: {layer:{}, action : ''},
  }),
  getters: {
    getSettings: (state) => state.settings,
    user: (state) => state.utilisateurConnecte,
    getRoleAPI: (state): string => {
      const mapRoles: Record<string, number> = {
        'ROLE_SUPER_ADMIN': 4,
        'ROLE_ADMIN': 3,
        'ROLE_AGENCE': 2, 'ROLE_VISUALISATEUR': 2, 'ROLE_COLLECTEUR': 2, 'ROLE_ENTREPRISE': 2,
        'ROLE_USER': 1,
      };
      if (!state.roles || state.roles.length === 0) return '';

      return state.roles.reduce((maxRole, currentRole) => {
        const maxVal = mapRoles[maxRole] ?? 0;
        const currentVal = mapRoles[currentRole] ?? 0;
        return currentVal > maxVal ? currentRole : maxRole;
      });
    },
    getRoles: (state): Array<String> => state.roles ?? [],
    getCompanieWorkId: (state): number => state.companieWork ?? -1,
    getAccessToken: (state): string => state.access_token,
    isConnect: (state) => state.connect,
    userInfo: (state) => {
      return {
        id: state.utilisateurConnecte.id,
        name: state.utilisateurConnecte.name,
        photo: avatar,
        curr_project: state.currentProject,
      }
    },
    getLanguage: (state): string => state.language,
    getRoleProject: (state): Object => state.currentProject.role,
    isAdminProject(): boolean {
      return this.currentProject.role.id === 1 || this.isAdmin;
    },
    isProjectManagerProject(): boolean {
      return this.currentProject.role.id === 2;
    },
    isTeamMemberProject(): boolean {
      return this.currentProject.role.id === 3;
    },
    isProjectCollecterProject(): boolean {
      return this.currentProject.role.id === 4;
    },
    isObserverProject(): boolean {
      return this.currentProject.role.id === 5;
    },
    isProjectSuperviserProject(): boolean {
      return this.currentProject.role.id === 6;
    },
    isAdmin(): boolean {
      return this.getRoles.includes('ROLE_SUPER_ADMIN') || this.getRoles.includes('ROLE_ADMIN');
    },
    isSuperAdmin(): boolean {
      return this.getRoles.includes('ROLE_SUPER_ADMIN');
    },
    getStudyId: (state): Object => state.currentStudy.idStudy,
    //getLayerdata: (state): any => state.layerdata,
    getLayerdata: (state) => {
      return {
        layer: state.layerdata.layer,
        action: state.layerdata.action,
      }
    },

  },
  actions: {
    setLanguage(lang: string) {
      this.language = lang;
    },
    setUser(userData: any) {
      this.utilisateurConnecte = userData;
      this.connect = true;
      this.roles = userData.roles;
      this.access_token = userData.access_token;
      this.settings = userData.settings;
      this.companieWork = userData.companieWork;

      // Sauvegarde dans Local Storage
      localStorage.setItem('utilisateurConnecte', JSON.stringify(userData));
    },
    disconnect() {
      this.utilisateurConnecte = { id: 0, name: 'Doe', firstname: 'John' };
      this.connect = false;
      this.currentProject = { id: '', project: '', role: '' };
      this.roles = [];
      this.access_token = '';
      // Suppression des données du Local Storage
      localStorage.removeItem('utilisateurConnecte');
    },
    setCurrentProject(id: string, name: string, nameRole: string) {
      this.currentProject = { id: id, project: name, role: nameRole }
    },
    setCurrentProjectRole(nameRole: string) {
      this.currentProject.role = nameRole;
    },
    setCurrentStudy(idStudy: string, name: string, codStudy: string, applicationId: string) {
      this.currentStudy = { idStudy: idStudy, codStudy: codStudy, name: name, applicationId: applicationId }
    },
    setCurrentTypeDatabaseConnection(type: string, name: string, codStudy: string, applicationId: string) {
      this.currentTypeDatabaseConnection = { type: type, codStudy: codStudy, name: name, applicationId: applicationId }
    },
    setLayerdata(layer: any, action : string) {
      this.layerdata = { layer: layer, action: action };
    },
  },
  persist: true,
});
